import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { NotificationsProvider } from './context/NotificationsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import POS from './pages/POS';
import Login from './pages/Login';
import AIAssistant from './pages/AIAssistant';
import Medicines from './pages/Medicines';
import NewMedicine from './pages/NewMedicine';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import SalesHistory from './pages/SalesHistory';
import DailyClosing from './pages/DailyClosing';
import MonthlyClosing from './pages/MonthlyClosing';
import Categories from './pages/Categories';
import Suppliers from './pages/Suppliers';
import SupplierDetail from './pages/SupplierDetail';
import ExpiryAlerts from './pages/ExpiryAlerts';
import LowStock from './pages/LowStock';
import DamageAlerts from './pages/DamageAlerts';
import Purchases from './pages/Purchases';
import Refunds from './pages/Refunds';
import Expenses from './pages/Expenses';
import Accounting from './pages/Accounting';
import Staff from './pages/Staff';
import StaffDetail from './pages/StaffDetail';
import Users from './pages/Users';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Backup from './pages/Backup';
import { useEffect } from 'react';
import syncService from './services/syncService';
import { useAuth } from './context/AuthContext';

function SyncInitializer() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    syncService.init();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      syncService.checkConnectivityAndSync();
    }
  }, [isAuthenticated]);

  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <SyncInitializer />
      <SettingsProvider>
        <NotificationsProvider>
        <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/pos" element={<POS />} />
            <Route path="/sales" element={<SalesHistory />} />
            <Route path="/daily-closing" element={<DailyClosing />} />
            <Route path="/monthly-closing" element={<MonthlyClosing />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            <Route path="/medicines" element={<Medicines />} />
            <Route path="/medicines/new" element={<NewMedicine />} />
            <Route path="/medicines/:id/edit" element={<NewMedicine />} />
            <Route path="/expiry-alerts" element={<ExpiryAlerts />} />
            <Route path="/low-stock" element={<LowStock />} />
            <Route path="/damage-alerts" element={<DamageAlerts />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/suppliers/:id" element={<SupplierDetail />} />
            <Route path="/purchases" element={<Purchases />} />
            <Route path="/refunds/customer" element={<Refunds />} />
            <Route path="/refunds/supplier" element={<Refunds />} />
            <Route path="/refunds" element={<Refunds />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/accounting" element={<Accounting />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/staff/:id" element={<StaffDetail />} />
            <Route path="/users" element={<Users />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/backup" element={<Backup />} />
            <Route path="/ai-assistant" element={<AIAssistant />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
        </NotificationsProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
